<template>
  <layout-card>
    <div class="mb-3">
      <b-button variant="primary" block class="btn-fat" @click="login"
        >登入台北通查詢歸戶收據</b-button
      >
    </div>

    <divider tag="span" title="或" position="center" />

    <!-- 查詢收據 -->
    <validation-observer ref="manualFormObs" slim v-slot="{ handleSubmit }">
      <b-form
        ref="manualForm"
        @submit.prevent="handleSubmit(onUploadFormSubmit)"
        class="formInquire"
      >
        <validation-provider
          rules="required|alpha_num"
          v-slot="{ validated, valid, errors }"
          slim
          name="收據號碼"
        >
          <b-form-group
            label="收據號碼"
            label-sr-only
            label-for="inputReceiptNumber"
            :invalid-feedback="errors[0]"
          >
            <b-input
              id="inputReceiptNumber"
              title="收據號碼"
              placeholder="收據號碼"
              v-model="manualFormData.receiptNumber"
              :state="validated ? valid : null"
              autocomplete="off"
              spellcheck="false"
            />
          </b-form-group>
        </validation-provider>

        <validation-provider
          rules="required|numeric"
          v-slot="{ validated, valid, errors }"
          slim
          name="檢核碼"
        >
          <b-form-group
            label="檢核碼"
            label-sr-only
            label-for="inputReceiptCode"
            :invalid-feedback="errors[0]"
          >
            <b-input
              id="inputReceiptCode"
              title="檢核碼"
              placeholder="檢核碼"
              v-model.trim="manualFormData.checkCode"
              :state="validated ? valid : null"
              autocomplete="off"
              spellcheck="false"
            />
          </b-form-group>
        </validation-provider>

        <validation-provider
          rules="required"
          v-slot="{ validated, valid, errors }"
          slim
          name="驗證碼"
        >
          <b-form-group
            label="驗證碼"
            label-sr-only
            label-for="inputRecaptcha"
            :state="validated ? valid : null"
            :invalid-feedback="errors[0]"
          >
            <b-form-row>
              <b-col>
                <b-input
                  id="inputRecaptcha"
                  title="驗證碼"
                  placeholder="驗證碼"
                  v-model="manualFormData.recaptcha"
                  :state="validated ? valid : null"
                  autocomplete="off"
                  spellcheck="false"
                />
              </b-col>
              <b-col cols="auto" class="px-0">
                <sIdentify :identifyCode="identifyCode"></sIdentify>
              </b-col>
              <b-col cols="auto">
                <b-button
                  variant="white"
                  class="text-primary"
                  title="重新取得驗證碼"
                  @click="refreshCode"
                >
                  <i class="fas fa-undo"></i>
                  <span class="sr-only">重新取得驗證碼</span>
                </b-button>
              </b-col>
            </b-form-row>
          </b-form-group>
        </validation-provider>

        <div>
          <b-button variant="outline-primary" block class="btn-fat" type="button" @click="searchBtn"
            >依輸入的資料查詢收據</b-button
          >
        </div>
      </b-form>
    </validation-observer>

    <divider tag="span" title="或" position="center" />

    <!-- 驗證收據檔案 -->
    <validation-observer ref="uploadFormObs" slim v-slot="{ handleSubmit }">
      <b-form
        ref="uploadForm"
        @submit.prevent="handleSubmit(onUploadFormSubmit)"
        class="formInquire"
      >
        <validation-provider
          rules="required|mimes:application/pdf"
          v-slot="{ validated, valid, errors }"
          slim
          name="收據檔案"
        >
          <b-form-group
            label="收據檔案"
            label-sr-only
            label-for="inputReceiptFile"
            :state="validated ? valid : null"
            :invalid-feedback="errors[0]"
          >
            <b-form-file
              id="inputReceiptFile"
              title="收據檔案"
              placeholder="請選擇收據檔案"
              drop-placeholder="請選擇收據檔案"
              class="form-control-file ff-browse-text"
              browse-text=""
              accept="application/pdf"
              multiple
              v-model="uploadFormData.file"
              :state="validated ? valid : null"
              @change="previewFiles"
            />
          </b-form-group>
        </validation-provider>

        <div>
          <b-button variant="outline-primary" block class="btn-fat" type="submit" name="_dontcare"
            >驗證上傳的收據檔案</b-button
          >
        </div>
      </b-form>

      <!-- 戶役政btn -->
      <!-- <divider tag="span" title="或" position="center" />
      <div>
        <b-button
          variant="outline-primary"
          block
          class="btn-fat"
          name="_household"
          type="button"
          :to="{ name: 'householdInquiry' }"
          >查詢戶政收據</b-button
        >
      </div> -->

      <!-- 滿意度 -->
      <div style="margin-top: 15px">
        <a href="#" style="border-bottom: 1px solid" @click.prevent="rating()">填寫滿意度調查</a>
      </div>
    </validation-observer>
    <div class="note" style="font-size: 10px">
      <ul class="list list-number mt-3" style="padding-left: 12px">
        <li>
          本電子收據系統由機關依個別法規規定應載明事項辦理，對收據內容有疑義請逕洽收據開立機關承辦人。
        </li>
        <li>收據如經作廢，最新狀態請依平台顯示結果為主。</li>
        <li>每張收據僅能歸戶一次，取得收據者可歸戶至台北通帳戶(未限制需為繳款人本人)</li>
      </ul>
    </div>
    <!-- 滿意度 -->
    <div style="margin-top: 15px">
      <a href="#" style="border-bottom: 1px solid" @click.prevent="notice()"
        >「個人資料使用說明」暨「隱私權及資訊安全政策」</a
      >
    </div>
    <rating-modal ref="rating"></rating-modal>
    <!-- 「隱私權及資訊安全政策」暨「個人資料使用說明」 -->
    <notice-modal :title="'「個人資料使用說明」暨「隱私權及資訊安全政策」'"></notice-modal>
    <div class="row">
      <div class="col-10" style="padding-top: 10px; color: red">
        <span>{{ labelFront }}</span>
        <div
          v-if="isBulletin"
          :class="[active ? 'front-content-expansion' : '']"
          class="front-content"
          v-html="FrontContent"
        ></div>
      </div>
      <div v-if="isBulletin" class="col-2 front-btn">
        <div class="btn btn-secondary" @click="expansionActive">
          <span :class="[active ? 'fa-angle-up' : 'fa-angle-down']" class="fa"></span>
        </div>
      </div>
    </div>
  </layout-card>
</template>

<script>
import LayoutCard from '@/layouts/Card.vue';

import ApiMixin from '@/mixins/api';
import CommonApiMixin from '@/mixins/commonApi';
import UserMixin from '@/mixins/user';
import verifyMixin from '@/mixins/verify';

import sleep from '@/utils/sleep';
import { mapMutations } from 'vuex';

export default {
  name: 'PageHome',

  components: {
    LayoutCard,
  },

  mixins: [ApiMixin, CommonApiMixin, UserMixin, verifyMixin],

  data() {
    return {
      token: '',
      manualFormData: {
        receiptNumber: '',
        checkCode: '',
        recaptcha: '',
      },
      uploadFormData: {
        file: null,
      },
      agreement: false,
      detailData: [],
      identifyCode: '',
      identifyCodes: '23456789abcdefghkmnpqrstuvwxyz23456789ABCDEFGHKMNPQRSTUVWXYZ',
      detailDatas: [],
      formData: new FormData(),
      pdfUploadData: [],
      getUrl: {},
      // getCookieRunVal: '',
      isIE6: false,
      isIE7: false,
      isIE8: false,
      isIE9: false,
      isIE10: false,
      isIE11: false,
      isIE: false,
      isFF: false,
      isSa: false,
      isOp: false,
      isNN: false,
      isCh: false,
      isMa: false,
      isOther: false,
      active: false,
      isBulletin: false,
      labelFront: '',
      FrontContent: '',
    };
  },

  created() {
    // 初始化驗證碼
    this.$nextTick(() => {
      this.analysis();
      this.refreshCode();
      console.log(`您的作業系統是:${this.detectOS.split(',')[0]}作業系統`);
      console.log(`您的瀏覽器是:${this.detectOS.split(',')[1]}瀏覽器`);
      // this.showApiMessage(
      //   'info',
      //   `您的作業系統是:${this.detectOS.split(',')[0]}作業系統<br>您的瀏覽器是:${
      //     this.detectOS.split(',')[1]
      //   }瀏覽器`,
      //   '系統判定'
      // );
      this.getBulletin();
    });
  },
  computed: {
    detectOS() {
      let msg = '';
      const sUserAgent = navigator.userAgent; // 定義使用者標籤資訊
      console.log(sUserAgent);

      // set1判定OS層標籤--------------------------------------

      // 判定windows電腦
      const isWin = navigator.platform === 'Win32' || navigator.platform === 'Windows';

      if (isWin) {
        if (sUserAgent.indexOf('Windows NT 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1) {
          msg = `${msg}Windows 2000,`;
        } else if (
          sUserAgent.indexOf('Windows NT 5.1') > -1 ||
          sUserAgent.indexOf('Windows XP') > -1
        ) {
          msg = `${msg}WinXP,`;
        } else if (
          sUserAgent.indexOf('Windows NT 5.2') > -1 ||
          sUserAgent.indexOf('Windows 2003') > -1
        ) {
          msg = `${msg}Win2003,`;
        } else if (
          sUserAgent.indexOf('Windows NT 6.0') > -1 ||
          sUserAgent.indexOf('Windows Vista') > -1
        ) {
          msg = `${msg}WinVista&fa-check,`;
        } else if (
          sUserAgent.indexOf('Windows NT 6.1') > -1 ||
          sUserAgent.indexOf('Windows 7') > -1
        ) {
          msg = `${msg}Win7&fa-check,`;
        } else if (
          sUserAgent.indexOf('Windows NT 6.2') > -1 ||
          sUserAgent.indexOf('Windows NT 6.3') > -1 ||
          sUserAgent.indexOf('Windows 8') > -1
        ) {
          msg = `${msg}Win8&fa-check,`;
        } else if (
          sUserAgent.indexOf('Windows NT 10.0') > -1 ||
          sUserAgent.indexOf('Windows 10.0') > -1
        ) {
          msg = `${msg}win10&fa-check,`;
        }
      }

      // 判定Mac電腦
      const isMac =
        navigator.platform === 'Mac68K' ||
        navigator.platform === 'MacPPC' ||
        navigator.platform === 'Macintosh' ||
        navigator.platform === 'MacIntel';
      if (isMac) {
        msg = `${msg}Mac&fa-check,`;
      }

      // 判定Unix電腦
      const isUnix = navigator.platform === 'X11' && !isWin && !isMac;
      if (isUnix) {
        msg = `${msg}Unix,`;
      }

      // 判定Linux電腦
      const isLinux = String(navigator.platform).indexOf('Linux') > -1;
      if (isLinux) {
        msg = `${msg}Linux,`;
      }

      // adr
      const isAndroid = sUserAgent.indexOf('Android') > -1 || sUserAgent.indexOf('Adr') > -1; // android终端
      if (isAndroid) {
        msg = `${msg}Android&fa-check,`;
      }

      // ios
      const isiOS = !!sUserAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        msg = `${msg}IPhone&fa-check,`;
      }

      // 其他區間OS判定
      if (msg === '') {
        msg = `${msg}OtherOS,`; // 如果以上都沒有，就會到此層做預設基礎
      }

      // set2判定Browser層標籤--------------------------------------

      if (sUserAgent.toLowerCase().indexOf('firefox') > -1) {
        msg = `${msg}Firefox&fa-check`;
      } else if (sUserAgent.toLowerCase().indexOf('opera') > -1) {
        msg = `${msg}Opera&fa-check`;
      } else if (sUserAgent.toLowerCase().indexOf('netscape') > -1) {
        msg = `${msg}Netscape`;
      } else if (sUserAgent.toLowerCase().indexOf('chrome') > -1) {
        msg = `${msg}Chrome&fa-check`;
      } else if (sUserAgent.toLowerCase().indexOf('safari') > -1) {
        msg = `${msg}Safari&fa-check`;
      } else if (sUserAgent.toLowerCase().indexOf('Edge') > -1) {
        msg = `${msg}Edge&fa-check`;
      } else if (sUserAgent.toLowerCase().indexOf('msie 6.0') > -1) {
        msg = `${msg}IE6`;
      } else if (sUserAgent.toLowerCase().indexOf('msie 7.0') > -1) {
        msg = `${msg}IE7`;
      } else if (sUserAgent.toLowerCase().indexOf('msie 8.0') > -1) {
        msg = `${msg}IE8`;
      } else if (sUserAgent.toLowerCase().indexOf('msie 9.0') > -1) {
        msg = `${msg}IE9`;
      } else if (sUserAgent.toLowerCase().indexOf('msie 10.0') > -1) {
        msg = `${msg}IE10&fa-check`;
      } else if (sUserAgent.toLowerCase().indexOf('gecko') > -1) {
        msg = `${msg}IE11&fa-check`;
      } else if (sUserAgent.toLowerCase().indexOf('msie') > -1) {
        msg = `${msg}IE6.0-7 marthon`;
      } else {
        msg = `${msg}OtherBrowser`;
      }

      return msg;
    },
  },
  methods: {
    // 驗證碼 相關方法
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = '';
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      console.log(o, l);
      for (let i = 0; i < l; i += 1) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
      console.log(this.identifyCode);
    },
    ...mapMutations('details', ['getDetailData', 'changeIsDetailData']),
    ...mapMutations('login', ['changeLogin']),

    // 查詢收據
    searchBtn() {
      const verify = this.manualFormData.recaptcha; // 驗證碼
      const data = {
        rpPublicRandomCode: this.manualFormData.checkCode,
        rpPublicNo: this.manualFormData.receiptNumber,
      };
      const url = '/GovEReceipt/FrontDeskService/QueryFNTSF';
      this.$_verifySearch('manualFormObs', verify, data, url);
    },
    // 抓取上傳檔案名稱
    previewFiles(event) {
      this.formData = new FormData();
      for (let i = 0; i < event.target.files.length; i += 1) {
        this.formData.append('file', event.target.files[i]); // 用迴圈抓出多少筆再append回來
      }
    },

    async onUploadFormSubmit() {
      this.uploadSubmit();
    },
    // 上傳PDF檔
    async uploadSubmit() {
      this.apiStart();

      try {
        await sleep(1);
        this.apiStop();
        this.axiosServiceSend(
          this.formData,
          '/GovEReceipt/FrontDeskService/PDFUpload',
          'post',
          'PDFUpload'
        );
      } catch (error) {
        this.apiStop();
        console.error(error);
      }
    },
    // 登入
    login() {
      // this.getCookieRun();
      this.getCookieRunVal = this.$getUUID('sessionId');
      this.$userLogin();
    },
    // 滿意度調查
    rating() {
      this.$refs.rating.openRating();
    },
    // 戶役政 查詢
    householdBtn() {
      console.log('戶役政');
    },

    // 流量分析
    analysis() {
      const data = {
        faSource: 'TPGovEReceipt',
      };
      this.axiosServiceSend(data, '/GovEReceipt/Analysis/AnchorPointAnalysis', 'post', 'Analysis');
    },

    // 公告資訊
    getBulletin() {
      const data = {};
      this.axiosServiceSend(data, '/GovEReceipt/Bulletin/Query', 'post', 'Bulletin', null, 3000);
    },

    // 使用共用API結果
    success(type, res, other) {
      console.log(other);
      switch (type) {
        case 'Query':
          console.log(res.data.object[0]);
          if (res.data.object[0] === undefined) {
            this.showApiMessage('info', '收據號碼或檢核碼輸入不正確，請重新輸入', '訊息');
          } else {
            const data = res.data.object[0];
            this.detailData = data;
            console.log(data);
            this.getDetailData(this.detailData);
            this.changeIsDetailData(true);
            this.$router.push({
              name: 'details',
            });
            console.log('有嗎???');
          }
          break;
        case 'PDFUpload':
          console.log(res.data);
          this.pdfUploadData = res.data;
          this.pdfUploadData.forEach((element) => {
            console.log('element.reason-', element.reason);
            const item = element;
            if (element.reason !== null && element.reason !== undefined) {
              const reason = JSON.parse(element.reason);
              if (reason.rpStatus === '9') {
                item.isInvalid = true;
              } else {
                item.isInvalid = false;
              }
            } else {
              console.log('---------')
              item.isInvalid = false;
            }
          });
          console.log('PDFUpload', this.pdfUploadData);
          this.getDetailData(this.pdfUploadData);
          this.changeIsDetailData(true);
           this.$router.push('upload-result');
          break;
        case 'Analysis':
          console.log('Analysis', res);
          break;
        case 'Bulletin':
          this.isBulletin = true;
          this.labelFront = '系統公告';
          if (res.data.object != null) {
            this.FrontContent = res.data.object.stValue;
          }
          console.log('Bulletin', res);
          break;
        default:
          break;
      }
      this.apiLoading = false;
    },
    fail(type, error, other) {
      console.log('fail', type, error, other);
      switch (type) {
        case 'Query':
          console.log('Query', error);
          break;
        case 'PDFUpload':
          this.showApiMessage('error', '檔案格式不正確', '執行失敗');
          break;
        case 'Analysis':
          console.log('Analysis', error);
          break;
        case 'Bulletin':
          this.isBulletin = false;
          this.labelFront = '系統維護中，請稍後再試，謝謝!';
          console.log('Bulletin', error);
          break;
        default:
          break;
      }
      this.apiLoading = false;
    },
    closeWindow(){
      console.log('------closeWindow')
      window.top.close();
    },
    notice() {
      this.$root.$emit('bv::show::modal', 'modal-agreement');
    },
    expansionActive() {
      this.active = !this.active;
    },
  },
};
</script>
